module.exports = "<template>\n    <section>\n        <div class=\"buttons\">\n            <b-button>Button</b-button>\n\n            <b-button tag=\"a\"\n                href=\"https://buefy.org\"\n                target=\"_blank\">\n                Anchor\n            </b-button>\n\n            <b-button tag=\"input\"\n                native-type=\"submit\"\n                value=\"Submit input\" />\n        </div>\n    </section>\n</template>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/button/examples/ExTags.vue
// module id = 1323
// module chunks = 21